import type { ButtonProps, UnstyledButtonProps } from '@mantine/core';
import { Button, UnstyledButton as UnstyledButtonMantine } from '@mantine/core';

import { applyUiId } from '../Utils/applyComponentGeneratedId';
import classes from './Button.module.css';

const ButtonDefaults = Button.extend({
  defaultProps: { size: 'lg', color: 'cobalt' }, // primary settings
  classNames: {
    root: classes.root,
    loader: classes.loader,
    inner: classes.inner,
    section: classes.section,
    label: classes.label,
  },
});

//TODO: @acdodd17 revisit this...
// const useResetButtonStyles = createStyles(() => ({
//   resetButtonStyles: {
//     textAlign: 'left',
//     border: 'none',
//   },
// }));

const ButtonMantine = applyUiId(Button, 'button');
const UnstyledButton = applyUiId(UnstyledButtonMantine, 'unstyled-button');

export { Button, ButtonDefaults, ButtonMantine, UnstyledButton };
export type { ButtonProps, UnstyledButtonProps };
